import type { z } from "zod";

/**
 * Reine Auth-Helfer (TES-848), extrahiert aus Auth.tsx.
 * Verhaltenserhaltend — identische Logik wie zuvor inline.
 */

export interface SsoProvider {
  id: string;
  display_name: string | null;
  sso_domains: string[] | null;
  supabase_provider_id: string | null;
}

/**
 * Extrahiert Feld-Fehler aus einem ZodError in ein flaches Record.
 * Optionaler `prefix` (z.B. 'reset_') wird jedem Feld-Key vorangestellt.
 */
export const parseZodErrors = (err: z.ZodError, prefix = ""): Record<string, string> => {
  const fieldErrors: Record<string, string> = {};
  err.issues.forEach((e) => {
    const field = e.path[0];
    if (typeof field === "string") fieldErrors[`${prefix}${field}`] = e.message;
  });
  return fieldErrors;
};

/** Extrahiert den (lowercase-getrimmten) Domain-Teil einer E-Mail, oder undefined. */
export const extractEmailDomain = (email: string): string | undefined => {
  return email.trim().toLowerCase().split("@")[1];
};

/** true, wenn irgendein Provider die gegebene Domain (case-insensitiv) bedient. */
export const domainMatchesProvider = (
  domain: string | undefined,
  providers: SsoProvider[],
): boolean => {
  if (!domain) return false;
  return providers.some((p) => p.sso_domains?.some((d) => d.toLowerCase() === domain));
};

/** Findet den ersten Provider, der die gegebene Domain (case-insensitiv) bedient. */
export const findProviderForDomain = (
  domain: string | undefined,
  providers: SsoProvider[],
): SsoProvider | undefined => {
  if (!domain) return undefined;
  return providers.find((p) => p.sso_domains?.some((d) => d.toLowerCase() === domain));
};
